import React, { Component } from "react";
import CustomButton from "../../../../components/inputs/button";
import TextField from "../../../../components/inputs/textfield";
import Snackbar from "../../../../components/snackbar/snackbar";
import {
  admin_event_booking_accept,
  interadmin_event_booking_accept,
  admin_event_booking_reject,
  interadmin_event_booking_reject,
  cfo_payment_accept,
  admin_event_booking_approve,
  admin_event_booking_submit,
  admin_event_booking_revert,
} from "../../admin.api";
import "./dialog.css";
import Swal from "sweetalert2";

let required = [
  "banner_location_text_ma",
  "notification_title_ma",
  "notification_desc_ma",
  "notification_desc_en",
];
class Dialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      formData: props.formData,
      adminType: props.adminType,
      edit: props.edit,
      submitted: false,
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
      data: props.data,
    };
  }

  componentWillReceiveProps = (props) => {
    this.setState({
      open: props.open,
      edit: props.edit,
      formData: props.formData,
      adminType: props.adminType,
    });
  };
  handleChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;

    this.setState({ formData: { ...this.state.formData, [name]: value } });
  };
  handleChangeDetails = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      match: {
        ...prevState.match,
        [name]: value,
      },
    }));
  };

  snackbarClose = (flag) => {
    this.setState({
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
    });
    if (!flag) {
      this.props.handleClose();
    }
  };
  handleApprove = (e) => {
    interadmin_event_booking_accept(this.state.formData.uuid)
      .then((res) => {
        this.setState({
          open: false,
          submitted: true,

          snackMessage: res.message,
          isSnackError: false,
          snackOpen: true,
        });
      })
      .catch((error) => {
        this.setState({
          submitted: false,
          snackMessage: error.message,
          isSnackError: true,
          snackOpen: true,
        });
      });
  };
  handlePaymentConfirmation = (e) => {
    const { formData } = this.state;
    const payload = {
      ...(formData.uuid ? { uuid: formData.uuid } : {}),
      ...(formData.bank_details ? { bank_details: formData.bank_details } : {}),
      ...(formData.reference_no ? { reference_no: formData.reference_no } : {}),
      ...(formData.transaction_date
        ? { transaction_date: formData.transaction_date }
        : {}),
      ...(formData.mode ? { mode: formData.mode } : {}),
      ...(formData.paid_amount ? { paid_amount: formData.paid_amount } : {}),
    };
    cfo_payment_accept(this.state.formData.uuid, payload)
      .then((res) => {
        this.setState({
          open: false,
          submitted: true,
          snackMessage: res.message,
          isSnackError: false,
          snackOpen: true,
        });
      })
      .catch((error) => {
        this.setState({
          submitted: false,
          snackMessage: error.message,
          isSnackError: true,
          snackOpen: true,
        });
      });
  };

  handleRecommend = (uuid) => {
    admin_event_booking_approve(uuid)
      .then((res) => {
        this.setState({
          open: false,
          submitted: true,
          snackMessage: res.message,
          isSnackError: false,
          snackOpen: true,
        });
      })
      .catch((error) => {
        this.setState({
          submitted: false,
          snackMessage: error.message,
          isSnackError: true,
          snackOpen: true,
        });
      });
  };
  handleSubmitAcceptance = (uuid) => {
    const { formData, adminType } = this.state;

    if (formData?.super_admin_message) {
      Swal.fire({
        title: "Message to Super Admin",
        input: "textarea",
        inputLabel: "Provide a message to the Super Admin",
        showCancelButton: true,
        confirmButtonColor: "#0A223D",
        confirmButtonText: "Submit",
        cancelButtonText: "Cancel",
        inputAttributes: {
          "aria-label": "Type your message here",
        },
        inputValidator: (value) => {
          if (!value.trim()) {
            return "Please enter a message";
          }
        },
      }).then((result) => {
        if (result.isConfirmed && result.value.trim()) {
          const data = {
            uuid: uuid,
            admin_message: result.value,
          };

          this.submitAcceptanceRequest(data);
        }
      });
    } else {
      const data = { uuid: uuid };
      this.submitAcceptanceRequest(data);
    }
  };

  submitAcceptanceRequest = (data) => {
    const { uuid, admin_message } = data;
    const payload = admin_message ? { admin_message } : undefined;
    admin_event_booking_submit(uuid, payload)
      .then((res) => {
        this.setState({
          open: false,
          submitted: true,
          snackMessage: res.message,
          isSnackError: false,
          snackOpen: true,
        });
      })
      .catch((error) => {
        this.setState({
          submitted: false,
          snackMessage: error.message,
          isSnackError: true,
          snackOpen: true,
        });
      });
  };

  handleReject = (e) => {
    interadmin_event_booking_reject(this.state.formData.id)
      .then((res) => {
        this.setState({
          submitted: true,

          snackMessage: res.message,
          isSnackError: false,
          snackOpen: true,
        });
      })
      .catch((error) => {
        this.setState({
          submitted: false,
          snackMessage: error.message,
          isSnackError: true,
          snackOpen: true,
        });
      });
  };
  // saMessage = (status) => {
  //   Swal.fire({
  //     title: "Message",
  //     input: "textarea",
  //     inputLabel: "Provide a reason",
  //     showCancelButton: true,
  //     confirmButtonColor: "#0A223D",
  //     confirmButtonText: "Submit",
  //     cancelButtonText: "Cancel",
  //     inputAttributes: {
  //       "aria-label": "Type your message here",
  //     },
  //     inputValidator: (value) => {
  //       if (!value.trim()) {
  //         return "Please describe the reason";
  //       }
  //     },
  //   }).then((message) => {
  //     if (message.isConfirmed && message.value.trim()) {
  //       let rpdetails = this.state.formData?.id;

  //       if (!rpdetails) {
  //         console.error("ID is missing.");
  //         this.setState({
  //           snackMessage: "Error: ID is missing.",
  //           isSnackError: true,
  //           snackOpen: true,
  //         });
  //         return;
  //       }

  //       let rdata = {
  //         status: status,
  //         rp_id: rpdetails,
  //         revert_reason: message.value,
  //       };

  //       if (this.state.adminType === 1) {
  //         rdata[status === 1 ? "admin_message" : "user_message"] =
  //           message.value;
  //       } else {
  //         rdata["super_admin_message"] = message.value;
  //       }

  //       this.setState({ isActive: true });
  //       admin_event_booking_revert(rpdetails, rdata)
  //         .then((res) => {
  //           this.setState({
  //             snackMessage: res?.message || "Action successful",
  //             isSnackError: false,
  //             snackOpen: true,
  //           });
  //         })
  //         .catch((error) => {
  //           this.setState({
  //             snackMessage:
  //               error.response?.data?.message || "Error processing request",
  //             isSnackError: true,
  //             snackOpen: true,
  //           });
  //         })
  //         .finally(() => {
  //           this.setState({ isActive: false });
  //         });
  //     }
  //   });
  // };
  saMessage = (status) => {
    Swal.fire({
      title: "Message",
      input: "textarea",
      inputLabel: "Provide a reason",
      showCancelButton: true,
      confirmButtonColor: "#0A223D",
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      inputAttributes: {
        "aria-label": "Type your message here",
      },
      inputValidator: (value) => {
        if (!value.trim()) {
          return "Please describe the reason";
        }
      },
    }).then((message) => {
      if (message.isConfirmed && message.value.trim()) {
        let rpdetails = this.state.formData?.id;

        if (!rpdetails) {
          console.error("ID is missing.");
          this.setState({
            snackMessage: "Error: ID is missing.",
            isSnackError: true,
            snackOpen: true,
          });
          return;
        }

        let rdata = {
          status: status,
          rp_id: rpdetails,
          revert_reason: message.value,
        };

        if (this.state.adminType === 1) {
          rdata[status === 1 ? "admin_message" : "user_message"] =
            message.value;
        } else {
          rdata["super_admin_message"] = message.value;
        }

        this.setState({ isActive: true });
        admin_event_booking_revert(rpdetails, rdata)
          .then((res) => {
            this.setState({
              snackMessage: res?.message || "Action successful",
              isSnackError: false,
              snackOpen: true,
            });
          })
          .catch((error) => {
            this.setState({
              snackMessage:
                error.response?.data?.message || "Error processing request",
              isSnackError: true,
              snackOpen: true,
            });
          })
          .finally(() => {
            this.setState({ isActive: false });
          });
      }
    });
  };
  handleDownload = (data) => {
    const servInstance = process.env.REACT_APP_BASE_URL;
    let result = servInstance.substring(0, servInstance?.length - 4);

    let path = `${result}${data.verification_document}`;
    window.open(path, "_blank");
  };

  render() {
    const { submitted, formData, adminType, open, edit, data } = this.state;
    const { view } = this.props;
    return (
      <React.Fragment>
        {open && (
          <React.Fragment>
            <div className="overlay">
              <div className="dia-big-event-actiity dialog">
                <div className="row">
                  <div className="flexDisplay">
                    <div className="diaTitleCon">
                      {edit
                        ? "Edit Events"
                        : view
                        ? "Event Registration Details"
                        : "Add Events"}
                    </div>
                    <div className="dia-close" onClick={this.props.handleClose}>
                      <div className="diaCloseCon">
                        <div className="diaClose">&#10005;</div>
                      </div>
                    </div>
                  </div>
                  <div className="tilebar">
                    <hr />
                  </div>
                  <form action="">
                    <div className="row event-booking-form">
                      <div className="col-6">
                        <TextField
                          id="outlined-basic"
                          disabled={view}
                          label=" Event Name"
                          variant="outlined"
                          onChange={(e) => this.handleChange(e)}
                          value={formData?.event_name_en ?? ""}
                          name="event_title_en"
                          required
                        />
                      </div>

                      <div className="col-6">
                        <TextField
                          id="outlined-basic"
                          disabled={view}
                          label="Organizer"
                          variant="outlined"
                          onChange={(e) => this.handleChange(e)}
                          value={formData?.oraganized_by_en ?? ""}
                          name="oraganized_by_en"
                          required
                        />
                      </div>

                      <div className="col-6">
                        <TextField
                          id="outlined-basic"
                          disabled={view}
                          label="User Name"
                          variant="outlined"
                          onChange={(e) => this.handleChange(e)}
                          value={formData?.full_name ?? ""}
                          name="full_name"
                          required
                        />
                      </div>
                      <div className="col-6">
                        <TextField
                          id="outlined-basic"
                          disabled={view}
                          label="Address"
                          variant="outlined"
                          onChange={(e) => this.handleChange(e)}
                          value={formData?.address ?? ""}
                          name="address"
                          type="text"
                          required
                        />
                      </div>
                      <div className="col-6">
                        <TextField
                          id="outlined-basic"
                          disabled={view}
                          label="Contact number"
                          variant="outlined"
                          onChange={(e) => this.handleChange(e)}
                          value={formData?.contact_no ?? ""}
                          name="contact_no"
                          type="number"
                          required
                        />
                      </div>
                      <div className="col-6">
                        <TextField
                          id="outlined-basic"
                          disabled={view}
                          label="Email"
                          variant="outlined"
                          value={formData?.email ?? ""}
                          name="email"
                          required
                        />
                      </div>

                      <div className="col-6">
                        <TextField
                          id="outlined-basic"
                          disabled={view}
                          label="Event Registration Date"
                          variant="outlined"
                          onChange={(e) => this.handleChange(e)}
                          value={formData?.event_booking_date ?? ""}
                          name="event_booking_date"
                          required
                        />
                      </div>
                      {(formData?.booking_status_text === "Payment Done" ||
                        formData?.payment_status === 1) && (
                        <>
                          <div className="col-6">
                            <TextField
                              id="outlined-basic"
                              label="Bank Details"
                              variant="outlined"
                              onChange={this.handleChange}
                              value={formData?.bank_details ?? ""}
                              name="bank_details"
                              disabled={
                                formData?.booking_status === "4" ||
                                adminType != 23
                              }
                              required
                            />
                          </div>
                          <div className="col-6">
                            <TextField
                              id="reference-no"
                              label="Reference Number"
                              variant="outlined"
                              value={formData?.reference_no || ""}
                              name="reference_no"
                              disabled={
                                formData?.booking_status === "4" ||
                                adminType != 23
                              }
                              onChange={(e) => this.handleChange(e)}
                            />
                          </div>
                          <div className="col-6">
                            <TextField
                              id="transaction-date"
                              label="Transaction Date"
                              variant="outlined"
                              value={formData?.transaction_date || ""}
                              name="transaction_date"
                              disabled={
                                formData?.booking_status === "4" ||
                                adminType != 23
                              }
                              onChange={(e) => this.handleChange(e)}
                            />
                          </div>
                          <div className="col-6">
                            <TextField
                              id="payment-mode"
                              label="Payment Mode"
                              variant="outlined"
                              value={formData?.mode || ""}
                              name="mode"
                              disabled={
                                formData?.booking_status === "4" ||
                                adminType != 23
                              }
                              onChange={(e) => this.handleChange(e)}
                            />
                          </div>
                          <div className="col-6">
                            <TextField
                              id="paid-amount"
                              label="Amount Paid"
                              variant="outlined"
                              value={formData?.paid_amount || ""}
                              name="paid_amount"
                              disabled
                            />
                          </div>

                          {formData?.booking_status === "5" &&
                            formData?.super_admin_message && (
                              <div className="col-6">
                                <TextField
                                  id="super-admin-reason"
                                  label="Revert Reason"
                                  variant="outlined"
                                  value={formData?.super_admin_message || ""}
                                  name="super_admin_message"
                                  disabled
                                />
                              </div>
                            )}
                          {formData?.admin_message && (
                            <div className="col-6">
                              <TextField
                                id="admin-message"
                                label="Admin Message"
                                variant="outlined"
                                value={formData?.admin_message || ""}
                                name="admin_message"
                                disabled
                              />
                            </div>
                          )}
                        </>
                      )}
                      {formData?.verification_document && (
                        <div className="col-6">
                          <button
                            type="button"
                            onClick={(e) => this.handleDownload(formData)}
                            className="btn btn-document btn-dark "
                          >
                            Download Document
                          </button>
                        </div>
                      )}

                      {adminType === 1 &&
                        formData?.booking_status !== "4" &&
                        formData?.booking_status !== "3" &&
                        formData?.booking_status !== "1" && (
                          <React.Fragment>
                            <center></center>
                          </React.Fragment>
                        )}
                      {adminType === 2 && (
                        <React.Fragment>
                          {formData?.booking_status === "3" && (
                            <div className="d-flex justify-content-center"></div>
                          )}
                        </React.Fragment>
                      )}

                      {adminType === 23 && (
                        <React.Fragment>
                          <center>
                            {formData?.booking_status === "1" && (
                              <button
                                type="button"
                                className="btn btn-success event-booking-buttons"
                                onClick={(e) => {
                                  this.handlePaymentConfirmation(e);
                                }}
                              >
                                Final Acceptance with Payment Confirmation
                              </button>
                            )}

                            {formData?.booking_status === "0" && (
                              <button
                                type="button"
                                className="btn btn-danger event-booking-buttons"
                                onClick={(e) => {
                                  this.handlePaymentConfirmation(e);
                                }}
                              >
                                Final Acceptance without Payment Confirmation
                              </button>
                            )}
                          </center>
                        </React.Fragment>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
        {!this.state.isSnackError && (
          <Snackbar
            message={this.state.snackMessage}
            error={this.state.isSnackError}
            open={this.state.snackOpen}
            close={this.snackbarClose}
          />
        )}
      </React.Fragment>
    );
  }
}

export default Dialog;
